import { Autocomplete, Box, Card, DialogTitle, FormControl, FormHelperText, IconButton, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from "react-redux";
import MDButton from "components/MDButton";
import { useNavigate } from "react-router-dom";
import { closeCustomModalDialog } from '../../redux/slices/modalSlice';
import { useEffect, useRef, useState } from "react";
import { stateList } from 'utilities/common';
import { openSnackbar } from "../../redux/slices/common";
import { getHomePageStateList, getStates } from "../../redux/slices/homePage";
import InfinitePaginationAutocomplete from "components/InfiniteAutoComplete";

export default function AddState({ closeModal }) {
    const pageRef = useRef(0);
    const [formData, setformData] = useState({
        template: "",
    });
    const liveStates = useSelector((state) => state.homePage.liveStates);
    const [states, setStates] = useState([]);
    const [liveStatess, setLiveStatess] = useState([])

    useEffect(() => {
        dispatch(getHomePageStateList({
            skip: pageRef.current,
            limit: 1000
        }))
            .unwrap()
            .then((res) => {
                pageRef.current = pageRef.current + 10;
                const mappedStates = (res?.data || []).map((item) => ({
                    value: item.stateName.toLowerCase().replace(/\s+/g, "_"),
                    label: item.stateName,
                    stateCode: item.stateCode,
                    _id: item._id,
                }));

                setStates(mappedStates);
            });
    }, []);


    useEffect(() => {
        dispatch(
            getStates({})
        )
            .unwrap()
            .then((res) => {
                const mappingStates = (res?.data || []).map((item) => ({
                    value: item.stateName.toLowerCase().replace(/\s+/g, "_"),
                    label: item.stateName,
                    StateCode: item.stateCode,
                }))
                setLiveStatess(res?.data);
            });
    }, []);


    const { modalData } = useSelector((state) => state.modal);

    const [errors, setErrors] = useState("");
    const { data } = modalData;


    const dispatch = useDispatch();
    const navigate = useNavigate();
    const handleSubmit = () => {

        // const exists = data.includes(formData.template)

        // if (exists) {
        //     showError("This State already exists", "error")
        //     dispatch(closeCustomModalDialog())
        //     return;
        // }

        // let errorObj = {}
        if (formData?.template === "") {

            // errorObj.template = "Template is required"
            setErrors("Template is required");
            return;
        }
        dispatch(closeCustomModalDialog());
        navigate(`/homepage/add?statename=${formData.template}`);
    };
    const showError = (message, errortype) => {
        if (errortype === "success") {
            dispatch(openSnackbar({ content: message, color: "success", icon: "check" }));
        }
        if (errortype === "error") {
            dispatch(openSnackbar({ content: message, color: "error", icon: "warning" }));
        }
    };


    return (
        <Card sx={{ py: 3, px: 4, borderRadius: 0 }} className="state-modal">
            <DialogTitle
                id="draggable-dialog-title"
                sx={{ p: 0, mb: 4 }}
                display="flex"
                alignItems="center"
                justifyContent="space-between"
            >
                State
                <IconButton onClick={closeModal} edge="end" size="small" className="modal-close">
                    <CloseIcon fontSize="medium" />
                </IconButton>
            </DialogTitle>
            <div className="create-page-template" style={{ paddingLeft: "0", paddingRight: "0" }}>
                <div className="select-static-pages" style={{ height: "50px" }}>
                    <Box className="filter-pro-status">
                        {/* <FormControl fullWidth>
                            <InputLabel>Select State</InputLabel>
                            <Select
                                size="small"
                                value={formData?.template || ""}
                                fullWidth
                                className="form-select"
                                name="status"
                                label="Select State"
                                onChange={(e) => {
                                    setErrors("");
                                    setformData({ ...formData, template: e.target.value });
                                }}
                            >
                                {stateList.map((row) => (

                                    <MenuItem key={row.stateCode} value={row.value}>{row.label}</MenuItem>

                                ))}

                            </Select>
                            {Boolean(errors) && <FormHelperText error>{errors}</FormHelperText>}
                        </FormControl> */}
                        <FormControl fullWidth className="auto-complete-field">
                            <Autocomplete
                                size="small"
                                className="form-select"
                                options={states.filter(state => !liveStatess.some((live) => live.stateCode === state.stateCode)) || []}
                                getOptionLabel={(option) => option.label || ""}
                                value={states?.find((s) => s.value === formData.template) || null}
                                isOptionEqualToValue={(option, value) => option.value === value.value}
                                onChange={(event, newValue) => {
                                    setErrors("");
                                    setformData({
                                        ...formData,
                                        template: newValue ? newValue.value : "",
                                    });
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Select State" />
                                )}
                            />
                            {Boolean(errors) && <FormHelperText error>{errors}</FormHelperText>}
                        </FormControl>
                    </Box>
                </div>
                <Box sx={{ mt: 2 }}>
                    <MDButton
                        sx={{ maxWidth: "160px" }}
                        type="button"
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                    //  dispatch(closeCustomModalDialog());
                    //   navigate("/create-home");
                    >
                        Save
                    </MDButton>
                </Box>
            </div>
        </Card>
    );

}